<template>
  <div>
    <multiselect
      class="form-control"
      v-model="modelo.idarea"
      :options="datos"
      track-by="id"
      label="nombre"
      :searchable="false"
      :close-on-select="true"
      :show-labels="false"
      placeholder="Seleccione..."></multiselect>
  </div>
</template>

<script>
  import gql from 'graphql-tag';
  import { parseJsonError } from '@/components/Utils.js';
  import { mapState } from 'vuex';
  export default {
    props: { model: Object, default: { type: Object, required: false, default: null } },
    data() {
      return {
        modelo: {
          idarea: null,
        },
      };
    },
    watch: {
      'modelo.idarea': function () {
        this.model.idarea = this.modelo.idarea;
      },
      default: function (a) {
        if (a == null) return;
        this.modelo.idarea = a;
      },
      UNIDAD_NEGOCIO_ID() {
        this.modelo = { idarea: null };
        this.getDatos();
      },
    },
    computed: {
      ...mapState({
        UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
        datos: (state) => {
          if (state.UNIDAD_NEGOCIO_ID) {
            return state.area.items.filter((item) => item.unidad_negocio_id == state.UNIDAD_NEGOCIO_ID);
          }
          return [];
        },
      }),
    },
    methods: {
      getDatos() {
        const sql = gql`query{getAreas(unidad_negocio_id:${this.UNIDAD_NEGOCIO_ID}){id,nombre,unidad_negocio_id}}`;
        this.$apollo
          .query({ query: sql })
          .then(({ data }) => {
            this.$store.dispatch('area/setAreas', data.getAreas);
            if (this.default != null) this.modelo.idarea = this.default;
          })
          .catch((error) => {
            window.console.error(error);
            this.$notify(parseJsonError(error, 'getAreas'));
          });
      },
    },
    mounted() {
      this.getDatos();
    },
  };
</script>
